import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const MuralFotoList = ({ muralFotos, podeGerenciar, handleOpenFoto, handleDeleteFoto, deletingCodigo }) => (
  <Box display="grid" gridTemplateColumns="repeat(auto-fill, minmax(180px, 1fr))" gap={1.5}>
    {muralFotos.map((mf, index) => (
      <Box
        key={mf.codigo}
        position="relative"
        sx={{
          aspectRatio: "1 / 1",
          borderRadius: 2,
          overflow: "hidden",
          bgcolor: "action.hover",
          "&:hover .mural-foto-acoes, &:focus-within .mural-foto-acoes": { opacity: 1 },
        }}
      >
        <ButtonBase
          onClick={() => handleOpenFoto(index)}
          aria-label={`Abrir foto ${index + 1}`}
          sx={{ width: "100%", height: "100%" }}
        >
          <Box
            component="img"
            src={mf.foto}
            alt=""
            loading="lazy"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              transition: "transform .3s",
              "&:hover": { transform: "scale(1.04)" },
            }}
          />
        </ButtonBase>
        {podeGerenciar && (
          <Box
            className="mural-foto-acoes"
            position="absolute"
            top={6}
            right={6}
            sx={{ opacity: { xs: 1, md: 0 }, transition: "opacity .2s" }}
          >
            <Tooltip title="Excluir foto">
              <span>
                <IconButton
                  size="small"
                  disabled={deletingCodigo === mf.codigo}
                  onClick={() => handleDeleteFoto(mf)}
                  sx={{ bgcolor: "background.paper", "&:hover": { bgcolor: "background.paper" } }}
                >
                  <DeleteOutlineIcon fontSize="small" color="error" />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        )}
      </Box>
    ))}
  </Box>
);

export default MuralFotoList;
